import { LevelConfig } from '../LevelConfig';
import { TemplateCave } from './TemplateCave';
import { TemplateComplete } from './TemplateComplete';
import { TemplateDungeon } from './TemplateDungeon';
import { TemplateMountains } from './TemplateMountains';
import { TemplateOrthographicCity } from './TemplateOrthographicCity';
import { TemplateOrthographicWay } from './TemplateOrthographicWay';
import { TemplatePlatformsVertical } from './TemplatePlatformsVertical';

import { TemplateBaseScene } from './TemplateBaseScene';
import { TemplatePlatformsWaterHeightmap } from './TemplatePlatformsWaterHeightmap';
import { TemplateTunnel } from './TemplateTunnel';
import { TemplateWayVertical } from './TemplateWayVertical';
import { TemplateWayWaterHeightmap } from './TemplateWayWaterHeightmap';

export interface LevelTemplate {
  create(): LevelConfig;
}

export type LevelTemplateKey =
  | 'Complete'
  | 'Dungeon'
  | 'Cave'
  | 'PlatformsWaterHeightmap'
  | 'PlatformsVertical'
  | 'WayVertical'
  | 'Tunnel'
  | 'Mountains'
  | 'BaseScene'
  | 'WayWaterHeightmap'
  | 'OrthographicWay'
  | 'OrthographicCity';

//export const LevelTemplateKeys: LevelTemplateKey[] = ['Complete', 'Dungeon', 'Cave', 'PlatformsWaterHeightmap', 'PlatformsVertical', 'WayWaterHeightmap', 'OrthographicWay', 'OrthographicCity', 'WayVertical', 'Tunnel', 'Mountains', 'BaseScene'];

export class LevelTemplateFactory {
  static get(key: LevelTemplateKey): LevelTemplate {
    switch (key) {
      case 'Complete':
        return new TemplateComplete();
      case 'Dungeon':
        return new TemplateDungeon();
      case 'Cave':
        return new TemplateCave();
      case 'PlatformsWaterHeightmap':
        return new TemplatePlatformsWaterHeightmap();
      case 'PlatformsVertical':
        return new TemplatePlatformsVertical();
      case 'WayWaterHeightmap':
        return new TemplateWayWaterHeightmap();
      case 'OrthographicWay':
        return new TemplateOrthographicWay();
      case 'OrthographicCity':
        return new TemplateOrthographicCity();
      case 'WayVertical':
        return new TemplateWayVertical();
      case 'Tunnel':
        return new TemplateTunnel();
      case 'Mountains':
        return new TemplateMountains();
      case 'BaseScene':
        return new TemplateBaseScene();
      default:
        throw new Error(`Unregistered level template: ${key}`);
    }
  }
}
